import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { closeAuthor, closeCategory } from "./Redux/PostReducer/Action";

function FilterButton() {
  const dispatch = useDispatch();
  const postReducer = useSelector((state) => state.postReducer);
  const { authorName, category } = postReducer;
  const handleCloseCategory = () => {
    dispatch(closeCategory());
  };
  const handleCloseAuthor = () => {
    dispatch(closeAuthor());
  };
  return (
    <div class="grid justify-items-start grid-cols-2">
      <button
        onClick={() => handleCloseAuthor()}
        type="button"
        className="justify-self-start rounded-md p-2 inline-flex items-center justify-center hover:text-green-500 text-indigo-800 hover:text-gray-500 hover:bg-gray-100"
      >
        {authorName && (
          <>
            {" "}
            Author Name: {authorName}
            <svg
              className="h-6 w-6"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              aria-hidden="true"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </>
        )}
      </button>
      <button
        onClick={() => handleCloseCategory()}
        type="button"
        className="justify-self-end rounded-md p-2 inline-flex items-center justify-center hover:text-green-500 text-indigo-800 hover:text-gray-500 hover:bg-gray-100"
      >
        {category && (
          <>
            {" "}
            Category: {category}
            <svg
              className="h-6 w-6"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              aria-hidden="true"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </>
        )}
      </button>
    </div>
  );
}

export default FilterButton;
